import { useTranslation } from 'react-i18next';
import { type UserSummary } from '@magimp/shared';
import { useRoleUsers } from '@magimp/shared-hooks';
import { LoadingState, ErrorState, RowCard, StatusBadge, useNarrow } from '../../../ui/index.js';
import { errorMessage } from '../../../api/errors.js';

export function RoleUsersTab({ roleId }: { roleId: string }) {
  const { t } = useTranslation(['roles', 'common', 'users']);
  const narrow = useNarrow();
  const usersQ = useRoleUsers(roleId);
  if (usersQ.isPending) return <LoadingState />;
  if (usersQ.error)
    return <ErrorState title={t('common:states.loadError')} text={errorMessage(usersQ.error)} />;
  if (usersQ.data.length === 0)
    return <p style={{ color: 'var(--fg-2)', fontSize: 13 }}>{t('roles:users.empty')}</p>;
  if (narrow) {
    return (
      <ul
        style={{
          listStyle: 'none',
          margin: 0,
          padding: 0,
          display: 'flex',
          flexDirection: 'column',
          gap: 8,
        }}
      >
        {usersQ.data.map((u: UserSummary) => (
          <li key={u.id} style={{ listStyle: 'none' }}>
            <RowCard
              ariaLabel={u.name}
              header={
                <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--fg-1)' }}>{u.name}</div>
              }
              actions={<StatusBadge status={u.active ? 'active' : 'inactive'} />}
              fields={[{ label: 'Email', value: u.email }]}
            />
          </li>
        ))}
      </ul>
    );
  }
  return (
    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
      <thead>
        <tr style={{ textAlign: 'left', color: 'var(--fg-2)', fontSize: 12 }}>
          <th style={{ padding: '6px' }}>Email</th>
          <th style={{ padding: '6px' }}>{t('users:fields.name')}</th>
          <th style={{ padding: '6px' }}>{t('users:fields.status')}</th>
        </tr>
      </thead>
      <tbody>
        {usersQ.data.map((u: UserSummary) => (
          <tr key={u.id} style={{ borderTop: '1px solid var(--border-2)' }}>
            <td style={{ padding: '8px 6px', fontSize: 13 }}>{u.email}</td>
            <td style={{ padding: '8px 6px', fontSize: 13 }}>{u.name}</td>
            <td style={{ padding: '8px 6px' }}>
              <StatusBadge status={u.active ? 'active' : 'inactive'} />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
